import Vue from 'vue'
import Router from 'vue-router'
import Button from './views/Button.vue'
import Settings from './views/Settings.vue'
import Callback from './views/Callback.vue'
import WixConnect from './components/WixConnect.vue'
import WixCallback from './components/WixCallback.vue'
import StatView from './components/StatView.vue'
// import DBUpdate from './components/DBUpdate.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'button',
      component: Button
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/wixconnect',
      name: 'wixconnect',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: WixConnect,
      props: (route) => ({ wixtoken: route.query.token })
    },
    {
      path: '/callback',
      name: 'callback',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Callback,
      props: (route) => ({ code: route.query.code, state: route.query.state })
    },
    {
      path: '/wixcallback',
      name: 'wixcallback',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: WixCallback,
      props: (route) => ({ code: route.query.code, instanceid: route.query.instanceId, state: route.query.state })
    },
    {
      path: '/statview',
      name: 'statview',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: StatView
    }
    /*
    {
      path: '/dbupdate',
      name: 'dbupdate',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: DBUpdate
    }
    */
  ]
})
